import { render, staticRenderFns } from "./ProductionParameters.vue?vue&type=template&id=5e5a3da0&scoped=true&"
import script from "./ProductionParameters.vue?vue&type=script&lang=js&"
export * from "./ProductionParameters.vue?vue&type=script&lang=js&"
import style0 from "./ProductionParameters.vue?vue&type=style&index=0&id=5e5a3da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a3da0",
  null
  
)

export default component.exports